import { Routes } from "@angular/router";
import { StandardLayoutComponent } from "./common/components/standard-layout/standard-layout.component";
import { LoginPageComponent } from "./common/components/login-page/login-page.component";
import { AuthGuard } from "./auth/auth.guard";
import { TestChatComponent } from './test-chat/test-chat.component';
import { FeatureFlagGuard } from "./auth/feature-flag-guard";
import {ErrorPageComponent} from "./common/components/error-page/error-page.component";
import {LogoutHandlerComponent} from "./common/components/logout-handler/logout-handler.component";
import { environment } from "../environments/environment";
import { TeachingRedirectGuard } from "./auth/insegnamento.guard";

export const routes: Routes = [
    {path: 'chat/standalone/public', redirectTo: 'overview', pathMatch: 'full'},
    {path: 'chat/:type/public', component: TestChatComponent},
    {path: 'chat/:type/private', component: TestChatComponent, canActivate: [AuthGuard]},
    {path: 'error-page', component: ErrorPageComponent},

    ...(environment.samlEnabled ? [
        {path: 'login-admin', component: LoginPageComponent},
        {path: 'logout-handler', component: LogoutHandlerComponent}
    ] : [
        {path: 'login', component: LoginPageComponent}
    ]),
    {
        path: "",
        component: StandardLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {path: '', redirectTo: 'home', pathMatch: 'full'},
            {
                path: "home",
                loadComponent: () =>
                    import("./features/select-insegnamento/select-insegnamento.component").then((c) => c.CambioInsegnamentoComponent),
                canActivate: [TeachingRedirectGuard]
            },
            {
                path: "overview",
                loadComponent: () =>
                    import("./features/overview/overview.component").then((c) => c.OverviewComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.OVERVIEW',
                    featureName: "overview",
                }
            },
            {
                path: "documents",
                loadComponent: () =>
                    import("./features/documenti/documenti.component").then((c) => c.DocumentiComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.DOCUMENTS',
                    featureName: 'document'
                }
            },
            {
                path: "settings",
                loadComponent: () =>
                    import("./features/settings/settings.component").then((c) => c.SettingsComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.SETTINGS',
                    featureName: 'settings',
                    requiresAdmin: true
                }
            },
            {
                path: "permissions",
                loadComponent: () =>
                    import("./features/permissions/permissions.component").then((c) => c.PermissionsComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.PERMISSIONS',
                    featureName: 'permissions',
                    requiresAdmin: true
                }
            },
            {
                path: "conversations",
                loadComponent: () =>
                    import("./features/conversations/conversations.component").then((c) => c.ConversationsComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.CONVERSATIONS',
                    featureName: 'conversations'
                }
            },
            {
                path: "examples",
                loadComponent: () =>
                    import("./features/examples/examples.component").then((c) => c.ExamplesComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.EXAMPLES',
                    featureName: 'examples',
                    entityType: 'assessment'
                }
            },
            {
                path: "tests",
                loadComponent: () =>
                    import("./features/examples/examples.component").then((c) => c.ExamplesComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.TESTS',
                    featureName: 'tests',
                    entityType: 'test'
                }
            },
            {
                path: "statistics",
                loadComponent: () =>
                    import("./features/statistics/statistics.component").then((c) => c.StatisticsComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.STATISTICS',
                    featureName: 'statistics'
                }
            },
            {
                path: "chunks",
                loadComponent: () =>
                    import("./features/chunks/chunks.component").then((c) => c.ChunksComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.CHUNKS',
                    featureName: 'chunk'
                }
            },
            {
                path: "ingestion-link",
                loadComponent: () =>
                    import("./features/ingestion-link/ingestion-link.component").then((c) => c.IngestionLinkComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'TABS.INGESTION_LINK',
                    featureName: 'ingestion-link'
                }
            },
            {
                path: "examples/manual-creation",
                loadComponent: () =>
                    import("./features/examples/manual-exam-creation/manual-exam-creation.component").then((c) => c.ManualExamCreationComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'Creazione di un Autovalutazione',
                    featureName: 'examples',
                    entityType: 'assessment'
                }
            },
            {
                path: "tests/manual-creation",
                loadComponent: () =>
                    import("./features/examples/manual-exam-creation/manual-exam-creation.component").then((c) => c.ManualExamCreationComponent),
                canActivate: [FeatureFlagGuard],
                data: {
                    title: 'Creazione di un Test',
                    featureName: 'tests',
                    entityType: 'test'
                }
            },
            // {
            //     path: "lumia/:id",
            //     loadComponent: () =>
            //         import("./features/lumia/lumia.component").then(
            //             (c) => c.LumiaComponent
            //         ),
            // },
        ],
    },
    {
        path: "examples/pdf-view",
        loadComponent: () =>
            import("./features/examples/exam-pdf-view/exam-pdf-view.component").then((c) => c.ExamPdfViewComponent),
        canActivate: [AuthGuard, FeatureFlagGuard],
        data: {
            title: 'Visualizzazione PDF Autovalutazione',
            featureName: 'examples',
            entityType: 'assessment'
        }
    },
    {
        path: "tests/pdf-view",
        loadComponent: () =>
            import("./features/examples/exam-pdf-view/exam-pdf-view.component").then((c) => c.ExamPdfViewComponent),
        canActivate: [AuthGuard, FeatureFlagGuard],
        data: {
            title: 'Visualizzazione PDF Test',
            featureName: 'tests',
            entityType: 'test'
        }
    },
    {
        path: '**',
        redirectTo: environment.samlEnabled ? '' : 'login'
    }
];